
import { useEffect } from 'react';
import HeroSection from './components/HeroSection';
import AboutExperience from './components/AboutExperience';
import GallerySection from './components/GallerySection';
import ServicesSection from './components/ServicesSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';
import SEOHead from '../../components/SEOHead';

export default function Home() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Idoel Photography - Starlight Christmas",
    "description": "Sesiones fotográficas navideñas premium con estilo cinematográfico en Patillas, Puerto Rico",
    "url": import.meta.env.VITE_SITE_URL || "https://example.com",
    "telephone": "787-459-9755",
    "email": "info@idoelphotography.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Urb. Valles de Patillas",
      "addressLocality": "Patillas",
      "addressRegion": "PR",
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "18.0061",
      "longitude": "-66.0158"
    },
    "openingHours": [
      "Mo-Fr 09:00-19:00",
      "Sa-Su 10:00-18:00"
    ],
    "priceRange": "$189-$389",
    "image": "https://static.readdy.ai/image/d7e77f925f0119a01fe5d8699c3ff655/28f8be5dd43d4646f0a482f1bebfa940.png",
    "sameAs": [
      "https://www.instagram.com/idoelphotography",
      "http://facebook.com/idoelphotography",
      "https://www.threads.com/@idoelphotography"
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Servicios de Fotografía Navideña",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Classic Christmas",
            "description": "Sesión navideña de 25 minutos con 10 fotos digitales editadas"
          },
          "price": "189",
          "priceCurrency": "USD"
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Magic Christmas",
            "description": "Sesión navideña de 45 minutos con todas las fotos digitales"
          },
          "price": "289",
          "priceCurrency": "USD"
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Starlight VIP",
            "description": "Sesión navideña premium de 90 minutos con experiencia completa"
          },
          "price": "389",
          "priceCurrency": "USD"
        }
      ]
    }
  };

  return (
    <div className="min-h-screen bg-black text-white overflow-x-hidden">
      <SEOHead
        title="Starlight Christmas Photo Session"
        description="Sesiones fotográficas navideñas premium con estilo cinematográfico. Captura recuerdos mágicos que brillan para siempre en esta temporada especial."
        keywords="fotografía navideña, sesiones familiares, retratos navideños, fotografía profesional, Patillas PR, sesiones fotográficas, idoel photography"
        url={import.meta.env.VITE_SITE_URL}
        structuredData={structuredData}
      />
      <HeroSection />
      <AboutExperience />
      <GallerySection />
      <ServicesSection />
      <TestimonialsSection />
      <FAQSection />
      <Footer />
    </div>
  );
}
